<template>
  <header>
    <b-navbar toggleable="lg" variant="primary" type="dark" fixed="top">
      <b-container>
        <b-navbar-brand :to="{ name: 'home' }" class="d-flex align-items-center">
          <span class="fa-stack logo">
            <i class="fas fa-map-marker fa-stack-2x"></i>
            <i class="fas fa-car fa-stack-1x"></i>
          </span>
          Kopcińskiego
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="mr-auto">
            <b-nav-item :to="{ name: 'regulamin' }" active-class="active">Regulamin</b-nav-item>
            <b-nav-item :to="{ name: 'about' }" active-class="active">Komitet</b-nav-item>
            <b-nav-item :to="{ name: 'oplaty' }" active-class="active">Opłaty</b-nav-item>
            <b-nav-item :to="{ name: 'walne-2019' }" active-class="active">
              Walne Zebranie
            </b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav>
            <b-nav-item :href="`mailto:${email}`">
              <i class="far fa-envelope fa-lg mr-2"></i>
              {{ email }}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </header>
</template>

<script>
export default {
  name: 'app-header',
  data() {
    return {
      email: 'parking.kopcinskiego@gmail.com',
    };
  },
};
</script>
